import { Monitor, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme, type Theme } from "@/lib/theme-context";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Toggle theme">
          <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <ThemeItem current={theme} value="light" icon={<Sun />} label="Light" onSelect={setTheme} />
        <ThemeItem current={theme} value="dark" icon={<Moon />} label="Dark" onSelect={setTheme} />
        <ThemeItem current={theme} value="system" icon={<Monitor />} label="System" onSelect={setTheme} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function ThemeItem({
  current,
  value,
  icon,
  label,
  onSelect,
}: {
  current: Theme;
  value: Theme;
  icon: React.ReactNode;
  label: string;
  onSelect: (next: Theme) => void;
}) {
  return (
    <DropdownMenuItem onClick={() => onSelect(value)} className="gap-2">
      {icon}
      <span className="flex-1">{label}</span>
      {current === value && <span className="text-xs text-muted-foreground">✓</span>}
    </DropdownMenuItem>
  );
}
